import { useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import emailjs from "emailjs-com";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FAQLight from "../faq/FAQLight";

const serviceID = process.env.REACT_APP_SERVICE_ID || "";
const templateID = process.env.REACT_APP_TEMPLATE_ID || "";
const publicKey = process.env.REACT_APP_PUBLIC_KEY || "";

function ContattiFAQ() {
  const { t } = useTranslation();

  const faqScherma = t("faq.principali", { returnObjects: true });

  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(serviceID, templateID, form.current, publicKey).then(
      (result) => {
        toast.success("Email inviata con successo!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        form.current.reset();
      },
      (error) => {
        toast.error("Errore durante l'invio, riprova.", {
          position: "top-right",
          autoClose: 3000,
        });
      },
    );
  };

  return (
    <section id="contatti" className="base-section">
      <div className="contact-section-container">
        <h2 className="base-title text-center">Domande prima di iniziare?</h2>
        <FAQLight faqList={faqScherma} />
        <div className="base-text-container mt-8">
          <Link to="/contatti" className="base-link">
            {t("faq.more")}
            <i className="fas fa-angle-right ml-1 text-xl text-current"></i>
          </Link>
        </div>
      </div>
      <div className="contact-section-container">
        <h2 className="base-title text-center">{t("contatti.title")}</h2>
        <p className="base-subtitle text-center">{t("contatti.subtitle")}</p>

        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <div>
            <label htmlFor="name" className="contact-label">
              {t("contatti.labelName")}
            </label>
            <input
              type="text"
              id="name"
              name="user_name"
              className="contact-input"
              placeholder={t("contatti.placeholderName")}
              required
            />
          </div>

          <div>
            <label htmlFor="email" className="contact-label">
              {t("contatti.labelEmail")}
            </label>
            <input
              type="email"
              id="email"
              name="user_email"
              className="contact-input"
              placeholder={t("contatti.placeholderEmail")}
              required
            />
          </div>

          <div>
            <label htmlFor="message" className="contact-label">
              {t("contatti.labelMessage")}
            </label>
            <textarea
              id="message"
              name="message"
              rows="6"
              className="contact-textarea"
              placeholder={t("contatti.placeholderMessage")}
              required
            />
          </div>

          <button type="submit" className="base-button">
            {t("contatti.sendButton")}
          </button>
        </form>

        <ToastContainer />
      </div>
    </section>
  );
}

export default ContattiFAQ;
